import isEmpty from 'lodash/isEmpty'
import { useState } from 'react'
import { Modal, ModalDragHandle } from '@ztechapps/webui.modal'
import { ModalBody, Modal as ModalCore } from 'react-bootstrap'
import { AddressDisplay } from '@ztechapps/webui.location'
import type { Address } from '@ztechapps/common.contract'
import { SaveCancelButtons } from '@ztechapps/webui.button'
import { HorizontalStack, NullComponent, ShowIf } from '@ztechapps/webui.util'
import { DataSuspense } from '@ztechapps/webui.util'
import { Form } from 'react-bootstrap'
import styles from './ExtractAddressModal.module.scss'

export type ExtractAddressModalProps = {
  addresses: Address[]
  loading: boolean
  error: Error | undefined
  onSelect: (address: Address) => void
  onCancel: () => void
  show: boolean
  onHide: () => void
}

export const ExtractAddressModal = ({
  addresses,
  loading,
  error,
  onSelect,
  onCancel,
  show,
  onHide,
}: ExtractAddressModalProps) => {
  const [selectedAddressId, setSelectedAddressId] = useState<string | null>(null)

  const handleSelect = () => {
    if (selectedAddressId) {
      const address = addresses.find((addr) => addr._id === selectedAddressId)
      if (address) {
        onSelect(address)
        onHide()
      }
    }
  }

  const handleCancel = () => {
    setSelectedAddressId(null)
    onCancel()
    onHide()
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      trigger={NullComponent}
      className={styles.extractAddressModalRaised}
      backdropClassName={styles.extractAddressBackdropRaised}
    >
      <ModalDragHandle>Select Extracted Address</ModalDragHandle>
      <ModalBody>
        <DataSuspense error={error} loading={loading}>
          <ShowIf condition={!loading && !error && isEmpty(addresses)}>
            <div className="text-center p-4">
              <p className="text-muted">No addresses found in email communications.</p>
            </div>
          </ShowIf>

          <ShowIf condition={!loading && !error && !isEmpty(addresses)}>
            <div>
              <p className="mb-3">Select an address from the extracted addresses:</p>
              <div className="mb-3">
                {addresses.map((address) => (
                  <div key={address._id} className="mb-3 p-3 border rounded">
                    <Form.Check
                      type="radio"
                      id={`address-${address._id}`}
                      name="address-selection"
                      checked={selectedAddressId === address._id}
                      onChange={() => setSelectedAddressId(address._id)}
                      label={
                        <div>
                          <AddressDisplay value={address} />
                        </div>
                      }
                    />
                  </div>
                ))}
              </div>
            </div>
          </ShowIf>
        </DataSuspense>
      </ModalBody>
      <ModalCore.Footer>
        <HorizontalStack gap={2} className="justify-content-end">
          <SaveCancelButtons
            onCancel={handleCancel}
            onSave={handleSelect}
            disabled={!selectedAddressId}
            saveText="Select"
            saveIcon="check"
            cancelText="Cancel"
          />
        </HorizontalStack>
      </ModalCore.Footer>
    </Modal>
  )
}
